import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons';
import { faGripVertical, faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans, useLingui } from '@lingui/react/macro';

const DEFAULT_BUTTON_CLASS =
  'vai-inline-flex vai-shrink-0 vai-items-center vai-gap-1.5 vai-h-8 vai-px-2.5 vai-rounded-full vai-text-sm vai-font-medium vai-leading-none vai-bg-leaf-600 vai-text-primary-foreground hover:vai-opacity-90 disabled:vai-opacity-50 vai-cursor-pointer vai-border-0';
const STAR_BUTTON_CLASS =
  'vai-shrink-0 vai-flex vai-items-center vai-justify-center vai-h-8 vai-w-8 vai-bg-transparent vai-border-0 vai-text-gray-400 hover:vai-text-gray-600 disabled:vai-opacity-50 vai-cursor-pointer';

export interface FieldValueRowProps {
  value: string;
  isDefault: boolean;
  isPending: boolean;
  onSetDefault: () => void;
}

export const FieldValueRow = ({
  value,
  isDefault,
  isPending,
  onSetDefault,
}: FieldValueRowProps) => {
  const { t } = useLingui();

  return (
    <li className="vai-flex vai-items-center vai-gap-3 vai-px-3 vai-py-3 vai-min-h-12 vai-bg-white hover:vai-bg-gray-50 vai-transition-colors">
      <span
        className="vai-text-gray-400 vai-cursor-grab vai-shrink-0"
        aria-hidden
      >
        <FontAwesomeIcon icon={faGripVertical} className="vai-h-4 vai-w-4" />
      </span>
      <span className="vai-flex-1 vai-min-w-0 vai-text-gray-900 vai-truncate">
        {value}
      </span>
      <button
        type="button"
        onClick={onSetDefault}
        disabled={isPending}
        title={t`Set as default`}
        aria-label={t`Set as default`}
        className={isDefault ? DEFAULT_BUTTON_CLASS : STAR_BUTTON_CLASS}
      >
        <FontAwesomeIcon
          icon={isDefault ? faStar : faStarRegular}
          className={isDefault ? 'vai-h-3.5 vai-w-3.5' : 'vai-h-4 vai-w-4'}
        />
        {isDefault && <Trans>Default</Trans>}
      </button>
    </li>
  );
};
